export function BrandMark({ className = "" }: { className?: string }) {
  return <img className={`brand-mark ${className}`} src="/apple-touch-icon-v3.png" alt="" aria-hidden="true" />;
}
